/**
 * WhatsApp helpers for form validation
 */

const MIN_WHATSAPP_DIGITS = 8;
const MAX_WHATSAPP_DIGITS = 15;

/**
 * Normalizes a WhatsApp number to digits only
 */
export const normalizeWhatsAppDigits = (value: string): string =>
  value.replace(/\D/g, "");

/**
 * Validates that a string contains enough digits for a WhatsApp link
 */
export const isValidWhatsAppNumber = (value: string): boolean => {
  const digits = normalizeWhatsAppDigits(value);
  return (
    digits.length >= MIN_WHATSAPP_DIGITS && digits.length <= MAX_WHATSAPP_DIGITS
  );
};
